<template>
  <v-layout column>
    <template v-for="(place, index) in unloadingPlaces">
      <v-layout
        :key="index"
        align-center
      >
        <UnloadingPlaceNumber :value="index + 1" />
        <v-text-field
          :key="index"
          :value="place.title"
          label="Место выгрузки"
          readonly
          hide-details
          outline
          height="40"
          :disabled="checkIsCanEdit(place)"
          class="my-1 ml-1"
        />
        <v-btn
          v-if="!menuRowActive"
          icon
          class="ma-0"
          @mouseover="menuRowActive = true"
        >
          <v-icon color="grey">
            more_vert
          </v-icon>
        </v-btn>
        <MenuRowActions
          v-else
          :list="rowActions"
          :value="place"
          :index="index"
          @remove="remove"
          @addUp="addUp(index)"
          @addDown="addDown(index)"
          @edit="openEditor"
        />
      </v-layout>
    </template>

    <v-dialog
      :value="showUnloadingPlaceEditor"
      persistent
      lazy
      width="1000"
    >
      <v-card>
        <v-card-title class="pb-1">
          <span class="title">Редактирование места выгрузки</span>
        </v-card-title>
        <v-card-text>
          <v-flex>
            <v-radio-group
              v-model="unloadingType"
              hide-details
              row
              height="25"
              class="my-0 mx-3"
            >
              <h2 class="subheading mr-2">
                Место отгрузки:
              </h2>
              <v-radio
                v-for="item in unloadingTypeItems"
                :key="item.value"
                :label="item.text"
                :value="item"
                @change="changeUnloadingType"
              />
            </v-radio-group>
            <UnloadingFactory
              v-if="unloadingType.value === unloadingPlaceTypes.FACTORY"
              :entity="unloadingPlace"
            />

            <UnloadingWarehouse
              v-if="
                unloadingType.value === unloadingPlaceTypes.GROUPEDWAREHOUSE
              "
              :entity="unloadingPlace"
              warehouse-mode="groupedWarehouse"
              @change="change"
            />

            <UnloadingAddress
              v-if="unloadingType.value === unloadingPlaceTypes.ADDRESS"
              :entity="unloadingPlace"
              @change="change"
            />

            <UnloadingWarehouse
              v-if="unloadingType.value === unloadingPlaceTypes.OTHERWAREHOUSE"
              :entity="unloadingPlace"
              warehouse-mode="otherWarehouse"
              @change="change"
            />
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-btn
            small
            :loading="loading"
            color="primary"
            @click="save"
          >
            Сохранить
          </v-btn>
          <v-btn
            small
            @click="closeEditor"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import UnloadingFactory from "./UnloadingFactory.vue";
import UnloadingWarehouse from "./UnloadingWarehouse.vue";
import UnloadingAddress from "./UnloadingAddress.vue";
import UnloadingPlaceNumber from "./UnloadingPlaceNumber.vue";
import {
  createUnloadingPlace,
  deleteUnloadingPlace,
  updateUnloadingPlace,
} from "../../../backend/routesApi.js";
import { unloadingPlaceTypes } from "../../../enums/unloading-place-types.js";

export default {
  components: {
    UnloadingFactory,
    UnloadingWarehouse,
    UnloadingAddress,
    UnloadingPlaceNumber,
  },
  data() {
    return {
      loading: false,
      showUnloadingPlaceEditor: false,
      unloadingTypeItems: [],
      unloadingType: null,
      unloadingPlace: {
        id: 0,
        order: 0,
        type: 0,
        unloadingCountry: null,
        unloadingFactory: null,
        unloadingWarehouse: null,
        unloadingAddress: null,
      },
      menuRowActive: false,
    };
  },
  computed: {
    unloadingPlaces() {
      return this.$store.getters["route/unloadingPlaces"];
    },
    route() {
      return this.$store.getters["route/getRoute"];
    },
    routeItems() {
      return this.$store.getters["route/routeItems"];
    },
    unloadingPlaceTypes() {
      return unloadingPlaceTypes;
    },
    rowActions() {
      return [
        {
          title: "Добавить вверх",
          name: "addUp",
          action: this.addUp,
          type: "icon",
          icon: "north",
          disabled: false,
        },
        {
          title: "Добавить вниз",
          name: "addDown",
          action: this.addDown,
          type: "icon",
          icon: "south",
          disabled: false,
        },
        {
          title: "Изменить",
          name: "edit",
          action: this.openEditor,
          type: "icon",
          icon: "edit",
          disabled: false,
        },
        {
          title: "Удалить",
          name: "remove",
          action: this.remove,
          type: "icon",
          icon: "delete",
          disabled: false,
        },
      ];
    },
  },
  created() {
    this.unloadingType = {
      value: this.unloadingPlaceTypes.FACTORY,
      text: "Склад продавца",
    };
    this.unloadingTypeItems = [
      {
        value: this.unloadingPlaceTypes.FACTORY,
        text: "Склад продавца",
      },
      {
        value: this.unloadingPlaceTypes.GROUPEDWAREHOUSE,
        text: "Группажный склад",
      },
      {
        value: this.unloadingPlaceTypes.ADDRESS,
        text: "Другое",
      },
      {
        value: this.unloadingPlaceTypes.OTHERWAREHOUSE,
        text: "Другой склад",
      },
    ];
  },
  methods: {
    change(entity) {
      this.unloadingPlace = {
        id: this.unloadingPlace.id,
        order: this.unloadingPlace.order,
        type: this.unloadingPlace.type,
        unloadingCountry: entity.unloadingCountry
          ? entity.unloadingCountry
          : null,
        unloadingFactory: entity.unloadingFactory
          ? entity.unloadingFactory
          : null,
        unloadingWarehouse: entity.unloadingWarehouse
          ? entity.unloadingWarehouse
          : null,
        unloadingAddress: entity.unloadingAddress
          ? entity.unloadingAddress
          : null,
      };
    },
    changeUnloadingType(type) {
      this.unloadingPlace.type = type;
    },
    async save() {
      this.loading = true;
      const newUnloadingPlace = {
        countryId: this.unloadingPlace.unloadingCountry
          ? this.unloadingPlace.unloadingCountry.id
          : null,
        factoryId: this.unloadingPlace.unloadingFactory
          ? this.unloadingPlace.unloadingFactory.id
          : null,
        warehouseId: this.unloadingPlace.unloadingWarehouse
          ? this.unloadingPlace.unloadingWarehouse.id
          : null,
        addressId: this.unloadingPlace.unloadingAddress
          ? this.unloadingPlace.unloadingAddress.id
          : null,
        order: this.unloadingPlace.order,
      };
      if (this.unloadingPlace.id !== 0) {
        await updateUnloadingPlace(
          this.route.id,
          this.unloadingPlace.id,
          newUnloadingPlace,
        );
      } else {
        await createUnloadingPlace(this.route.id, newUnloadingPlace);
      }
      this.$emit("change");
      this.closeEditor();
      this.loading = false;
    },
    async remove(unloadingPlace, index) {
      if (index == 0) {
        return;
      }
      await deleteUnloadingPlace(this.route.id, unloadingPlace.id);
      this.$emit("change");
    },
    openEditor(item) {
      this.showUnloadingPlaceEditor = true;
      this.unloadingType = item.type ? item.type : this.unloadingType;
      this.unloadingPlace = {
        id: item.id,
        type: item.type ? item.type : this.unloadingType,
        unloadingCountry: item.unloadingCountry ? item.unloadingCountry : null,
        unloadingFactory: item.unloadingFactory ? item.unloadingFactory : null,
        unloadingWarehouse: item.unloadingWarehouse
          ? item.unloadingWarehouse
          : null,
        unloadingAddress: item.unloadingAddress ? item.unloadingAddress : null,
      };
    },
    closeEditor() {
      this.showUnloadingPlaceEditor = false;
      this.unloadingType = {
        value: this.unloadingPlaceTypes.FACTORY,
        text: "Склад продавца",
      };
      this.unloadingPlace = {
        id: 0,
        type: this.unloadingType,
        unloadingCountry: null,
        unloadingFactory: null,
        unloadingWarehouse: null,
        unloadingAddress: null,
      };
    },
    checkIsCanEdit(place) {
      return !!this.routeItems.find(
        i => i.unloadingPlaceId === place.id && i.unloaded,
      );
    },
    addUp(index) {
      this.showUnloadingPlaceEditor = true;
      this.unloadingPlace.order = index;
    },
    addDown(index) {
      this.showUnloadingPlaceEditor = true;
      this.unloadingPlace.order = index + 1;
    },
  },
};
</script>
